<!--教科研-->
<template>
    <div class="container">
        <div class="wel-box">
            <div class="top-box">
                <homeHead ref="homeHead" />
            </div>
            <div class="course-container">
                <div class="left-menu-container">
                    <teach-research-menu :item-num="this.activeItem"
                                 @change-item="changeItem"/>
                </div>
                <!-- 课题引领 -->
                <div v-if="activeItem==='1'"  class="right-content-container">
                    <page-topic :course-mode="this.activeMode"
                                :filter-item="this.activeChildItem"
                                     @change-mode="changeMode"/>
                </div>

                <div v-if="activeItem==='2'"  class="right-content-container">
                    <page-race :course-mode="this.activeMode"
                                @change-mode="changeMode"/>
                </div>
                <div v-if="activeItem==='3'"  class="right-content-container">
                    <page-activity :course-mode="this.activeMode"
                                    @change-mode="changeMode"/>
                </div>
                <div v-if="activeItem==='4'"  class="right-content-container">
                    <page-achieve :course-mode="this.activeMode"
                                   @change-mode="changeMode"/>
                </div>


            </div>
        </div>
    </div>
</template>
<script>
import {timestampToTime} from "@/utils/date";
import homeHead from "@/components/homeHead.vue";
import dataEmpty from "@/components/dataEmpty.vue";
import teachResearchMenu from "@/components/teachResearch/teachResearchMenu.vue";
import pageTopic from "@/components/teachResearch/pageTopic.vue";
import pageRace from "@/components/teachResearch/pageRace.vue";
import pageActivity from "@/components/teachResearch/pageActivity.vue";
import pageAchieve from "@/components/teachResearch/pageAchieve.vue";
export default {
    components: {
        dataEmpty,
        homeHead,
        teachResearchMenu,
        pageTopic,
        pageRace,
        pageActivity,
        pageAchieve
    },
    name: "homeTeachResearch",
    data() {
        return {
            pageMode:"page",
            detailMode:"detail",
            timestampToTime,
            activePath: "homeTeachResearch",
            activeItem:"1",
            activeChildItem:"0",
            activeMode:"page",
        }
    },
    computed: {},
    watch: {},
    created() {
    },
    mounted() {
        this.$refs.homeHead.activePath = this.activePath;
        if (this.$store.state.params.jumpParams.activeItem){
            this.activeItem = this.$store.state.params.jumpParams.activeItem;
        }
    },
    methods: {
        changeItem(item,childItem){
            this.activeItem = item;
            this.activeChildItem = childItem;
            this.activeMode = this.pageMode;
            this.$store.commit("params/setJumpParams", {});
        },
        changeMode(mode){
            this.activeMode = mode;
        }
    }
}
</script>
<style scoped>
.container {
    width: 100%;
    height: 100%;
    margin: 0;
    overflow-y: auto!important;
    overflow-x: hidden;
    background-color: #f1f1f1;
}
.wel-box {
    width:100vw;
    height: auto;
    overflow-y: auto!important;
    .top-box{
        display: flex;
        width: 100vw;
        height: 70px;
        background: #3b62f8;
    }
}
.course-container{
    width: 100%;
    height: auto;
    border: 10px;
    box-sizing: border-box;
    display: flex;
}
.left-menu-container{
    width: 200px;
    height: auto;
    padding: 10px;
    box-sizing: border-box;
}
.right-content-container{
    width: calc(100% - 200px);
    height: auto;
    padding: 10px;
    box-sizing: border-box;
}
</style>